

// BigCommerce
export function getPathBigCommerceSettings() {
  return `/bigcommerce-settings`;
}

export function getPathEditBigCommerceSettings() {
  return `/bigcommerce-settings/edit`;
}

export function getPathBigCommerceActions() {
  return `/bigcommerce-actions`;
}


// EasyStore
export function getPathEasyStoreSettings() {
  return `/easystore-settings`;
}

export function getPathEditEasyStoreSettings() {
  return `/easystore-settings/edit`;
}

export function getPathEasyStoreActions() {
  return `/easystore-actions`;
}


// Shopify
export function getPathShopifySettings() {
  return `/shopify-settings`;
}

export function getPathEditShopifySettings() {
  return `/shopify-settings/edit`;
}

export function getPathShopifyActions() {
  return `/shopify-actions`;
}


// Shopline
export function getPathShoplineSettings() {
  return `/shopline-settings`;
}

export function getPathEditShoplineSettings() {
  return `/shopline-settings/edit`;
}

export function getPathShoplineActions() {
  return `/shopline-actions`;
}



// Wix
export function getPathWixSettings() {
  return `/wix-settings`;
}

export function getPathEditWixSettings() {
  return `/wix-settings/edit`;
}

export function getPathWixActions() {
  return `/wix-actions`;
}

